export default () => '/payment-groups';
